import { Trans } from "@lingui/macro";

export const SIGN_IN_RATE_LIMIT_EXCEEDED = {
  message: (
    <Trans id="sign-in.notification.rate-limit-description">
      You have made too many attempts, please try again later.
    </Trans>
  ),
};
